import React, {useEffect, useState} from 'react'
import {KTCard, KTCardBody, KTIcon} from "../../../_websoft/helpers"
import {ToastContainer} from "react-toastify"
import TableSearch from "../../components/TableSearch/TableSearch"
import ExportButton from "../../components/TableExportToExcel/ExportButton"
import {Link, useNavigate} from "react-router-dom"
import LoadingComponent from "../../components/LoadingComponent/LoadingComponent"

import {
    flexRender,
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    SortingState,
    useReactTable
} from "@tanstack/react-table"

import TablePagination from "../../components/TablePagination/TablePagination"

import {PaginationModel} from "../../models/PaginationModel"
import {ParamsModelGlavnaKnjiga} from "../../models/GlavnaKnjigaModel"
import notifyToast from "../../components/Toast/Toast"

import moment from "moment"

import {TableActionButton} from "../../components/TableActionBtn/TableActionButton"
import {DigitalniDopFormValues} from "../../models/DigitalniDopModel"

import {deleteDodjeljenuSifruDopu, getDopSifre, getPanelDops, saveDopSifra, validateSifra} from "../../api/paneliDop"
import axios from "axios"
import IzvjestajiModal from "./components/DopIzvjestaj/IzvjestajiModal";

type DopSifra = {
    Id: number
    sifra: string
}

const DigitalniDop = () => {

    const [data, setData] = useState<DigitalniDopFormValues[]>([])
    const [loading, setLoading] = useState(true)

    const [selectedId, setSelectedId] = useState<number | null>(null)

    const [showSifraModal, setShowSifraModal] = useState(false)
    const [sifraId, setSifraId] = useState<number | null>(null)

    const [dbSifre, setDbSifre] = useState<DopSifra[]>([])
    const [newSifre, setNewSifre] = useState<{ Id: number; sifra: string }[]>([])
    const [validation, setValidation] = useState<Record<string, boolean>>({})
    const [newSifraInput, setNewSifraInput] = useState('')
    const [savingSifre, setSavingSifre] = useState(false)

    const [showIzvjestajiModal, setShowIzvjestajiModal] = useState(false)


    const [pagination, setPagination] = useState<PaginationModel>({
        curPage: 1,
        totalPage: 1,
        perPage: 10,
    })

    const [params, setParams] = useState<ParamsModelGlavnaKnjiga>({
        per_page: 10,
        page: 1
    })

    const [sorting, setSorting] = useState<SortingState>([])
    const [globalFilter, setGlobalFilter] = useState('')

    const navigate = useNavigate()

    const updatePage = async () => {

        setLoading(true)

        try {

            const response = await getPanelDops(params)
            const rows = response.data.data

            setData(rows)

            setPagination({
                curPage: response.data.current_page,
                totalPage: response.data.last_page,
                perPage: response.data.per_page
            })

        } catch (error: any) {

            console.error(error)
            notifyToast(false, error)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        updatePage()
    }, [params])


    const openSifraModal = async (id: number) => {

        setSifraId(id)
        setShowSifraModal(true)

        try {

            const data = await getDopSifre(id)

            const sifre = data.map((item: any) => ({
                Id: item.Id,
                sifra: item.sifre_panela?.sifra
            }))

            setDbSifre(sifre)
            setNewSifre([])
            setValidation({})
            setNewSifraInput('')

        } catch (error) {

            console.error(error)
            notifyToast(false, "Greška kod učitavanja šifri")

        }
    }


    const addSifra = async () => {
        const sifra = newSifraInput.trim()

        if (!sifra) return

        if (dbSifre.some(s => s.sifra === sifra) || newSifre.some(s => s.sifra === sifra)) {
            notifyToast(false, "Šifra već postoji")
            return
        }

        try {
            const res = await validateSifra(sifra)

            if (!res?.valid) {
                notifyToast(false, "Šifra ne postoji")
                return
            }

            const panelSifraId = Number(res?.Id ?? res?.id)

            if (!panelSifraId) {
                console.error('validateSifra response missing Id:', res)
                notifyToast(false, "API nije vratio ID šifre")
                return
            }

            setNewSifre(prev => [
                ...prev,
                {
                    Id: panelSifraId,
                    sifra: sifra
                }
            ])

            setNewSifraInput('')

        } catch (error) {
            console.error(error)
            notifyToast(false, "Greška kod validacije")
        }
    }
    const removeDopSifra = async (item: DopSifra) => {
        try {
            const response = await deleteDodjeljenuSifruDopu(item.Id)

            setDbSifre(prev => prev.filter(s => s.Id !== item.Id))

            notifyToast(true, response.message || "Šifra uklonjena")

        } catch (error: any) {
            notifyToast(false, error.message || "Greška kod brisanja")
        }
    }


    const removeNewSifra = (sifra: string) => {

        setNewSifre(prev => prev.filter(s => s.sifra !== sifra))

        setValidation(prev => {
            const copy = { ...prev }
            delete copy[sifra]
            return copy
        })
    }


    const saveSifre = async () => {
        if (!sifraId) {
            notifyToast(false, "Nije odabran DOP")
            return
        }

        if (newSifre.length === 0) {
            notifyToast(false, "Nema novih šifri za snimanje")
            return
        }

        try {
            setSavingSifre(true)

            for (const sifra of newSifre) {
                if (!sifra.Id) {
                    console.error('Missing SifraId for item:', sifra)
                    notifyToast(false, `Šifra ${sifra.sifra} nema ID`)
                    continue
                }

                await saveDopSifra({
                    DopId: sifraId,
                    SifraId: sifra.Id
                })
            }

            notifyToast(true, "Šifre uspješno sačuvane")
            setShowSifraModal(false)

        } catch (error: any) {
            console.error(error)
            notifyToast(false, "Greška kod spašavanja")
        } finally {
            setSavingSifre(false)
        }
    }

    const columns = [
        {
            id: 'select',
            header: '',
            cell: ({row}: any) => (
                <input
                    type="checkbox"
                    className="form-check-input"
                    checked={selectedId === row.original.Id}
                    onChange={() =>
                        setSelectedId(prev => prev === row.original.Id ? null : row.original.Id)
                    }
                />
            )
        },
        {header: 'dop id', accessorKey: 'Id'},
        {header: 'Tip panela', accessorKey: 'TipPanela'},
        {
            id: 'izolacija',
            header: 'Izolacija',
            accessorFn: (row: any) => row?.izolacija_panela?.naziv ?? ''
        },
        {header: 'Proizvod', accessorKey: 'IdentifikacijskaOznakaVProizvoda'},
        {header: 'Standard', accessorKey: 'UskladjeniStandard'},
        {
            header: 'Priv. dop',
            accessorKey: 'PrivremeniDop',
            cell: ({row}: any) =>
                row.original.PrivremeniDop === 1 ?
                    <span className="text-success fw-bold fs-4">✔</span> :
                    <span className="text-danger fw-bold fs-4">✖</span>
        },
        {header: 'Nalog', accessorKey: 'BrojNaloga'},
        {
            id: 'datum',
            header: 'Datum',
            accessorFn: (row: any) =>
                row?.Kreirano ? moment(row.Kreirano).format('DD-MM-YYYY') : ''
        },
        {
            id: 'sifra',
            header: 'Sifra',
            cell: ({row}: any) => (
                <button
                    className="btn btn-sm btn-light-primary"
                    onClick={() => openSifraModal(row.original.Id)}
                >
                    <KTIcon iconName='code' className='fs-3'/>
                </button>
            )
        },
        {
            id: 'akcija',
            header: 'Akcija',
            cell: ({row}: any) => (
                <TableActionButton
                    onDelete={() => notifyToast(true, "Record deleted")}
                    onEdit={() => navigate(`/paneli/digitalni-dop/izmjena/${row.original.Id}`)}
                />
            ),
        },
    ]

    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        state: {sorting, globalFilter},
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter
    })


    return (

        <KTCard>

            <ToastContainer/>

            <KTCardBody className='py-4'>

                <div className='d-flex justify-content-between'>

                    <TableSearch onSearch={(text) => setGlobalFilter(text)}/>

                    <div className="d-flex align-items-center gap-2">
                        <Link to='/paneli/digitalni-dop-stavke'>
                            <button type='button' className='btn btn-light-danger'>
                                <KTIcon iconName='folder-up' className='fs-2' />
                                Stavke dopa
                            </button>
                        </Link>
                        <button
                            className='btn btn-light-info me-2'
                            onClick={() => setShowIzvjestajiModal(true)}
                        >
                            <KTIcon iconName='chart-line' className='fs-2' />
                            Izvještaji
                        </button>

                        <div className="btn btn-sm btn-light-primary p-0">
                            <ExportButton table={table} filename={'Digitalni-dop'}/>
                        </div>

                        <Link to='dodaj'>
                            <button className='btn btn-sm btn-primary d-flex align-items-center'>
                                <KTIcon iconName='plus' className='fs-4 me-1'/>
                                Dodaj
                            </button>
                        </Link>

                    </div>

                </div>

                {loading ? (
                    <LoadingComponent/>
                ) : (

                    <div className='table-responsive mt-6'>

                        <table className='table align-middle table-bordered gy-5 no-footer'>

                            <thead>
                            {table.getHeaderGroups().map(headerGroup => (
                                <tr key={headerGroup.id}
                                    className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-dark p-2'>
                                    {headerGroup.headers.map(header => (
                                        <th className='text-white' key={header.id}>
                                            {flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                            </thead>

                            <tbody className='text-gray-600'>

                            {table.getRowModel().rows.map(row => (

                                <tr key={row.id}>

                                    {row.getVisibleCells().map(cell => (

                                        <td key={cell.id}>
                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext()
                                            )}
                                        </td>

                                    ))}

                                </tr>

                            ))}

                            </tbody>

                        </table>

                    </div>

                )}

            </KTCardBody>


            {showSifraModal && (
                <div className="modal fade show d-block" style={{background: 'rgba(0,0,0,0.55)'}}>

                    <div className="modal-dialog modal-lg modal-dialog-centered">

                        <div className="modal-content shadow-lg">

                            {/* HEADER */}
                            <div className="modal-header border-0 pb-2">

                                <div>
                                    <h4 className="modal-title fw-bold">
                                        Dodijeljene šifre
                                    </h4>

                                    <div className="text-muted fs-7">
                                        Upravljanje šiframa panela za ovaj DOP
                                    </div>
                                </div>

                                <button
                                    className="btn btn-sm btn-icon btn-light"
                                    onClick={() => setShowSifraModal(false)}
                                >
                                    <KTIcon iconName="cross" className="fs-2"/>
                                </button>

                            </div>


                            {/* BODY */}
                            <div className="modal-body pt-3">

                                {/* DATABASE SIFRE */}
                                <div className="mb-7">

                                    <div className="d-flex align-items-center mb-3">

                                        <KTIcon iconName="database" className="fs-3 text-primary me-2"/>

                                        <h6 className="fw-bold mb-0">
                                            Šifre iz baze
                                        </h6>

                                    </div>

                                    <div className="bg-light rounded p-4">

                                        {dbSifre.length === 0 && (
                                            <div className="text-muted fs-7">
                                                Nema dodijeljenih šifri
                                            </div>
                                        )}

                                        <div className="d-flex flex-wrap gap-2">

                                            {dbSifre.map(item => (

                                                <span
                                                    key={item.Id}
                                                    className="badge badge-light-primary fs-6 px-3 py-2 d-flex align-items-center"
                                                >

                                        {item.sifra}

                                                    <span
                                                        className="ms-2 cursor-pointer text-danger"
                                                        onClick={() => removeDopSifra(item)}
                                                    >
                                            <KTIcon iconName="cross" className="fs-5"/>
                                        </span>

                                    </span>

                                            ))}

                                        </div>

                                    </div>

                                </div>


                                {/* NEW SIFRE */}
                                <div className="mb-7">

                                    <div className="d-flex align-items-center mb-3">

                                        <KTIcon iconName="plus-circle" className="fs-3 text-success me-2"/>

                                        <h6 className="fw-bold mb-0">
                                            Nove šifre
                                        </h6>

                                    </div>

                                    <div className="bg-light-success bg-opacity-25 rounded p-4">

                                        {newSifre.length === 0 && (
                                            <div className="text-muted fs-7">
                                                Nema novih šifri
                                            </div>
                                        )}

                                        <div className="d-flex flex-wrap gap-2">

                                            {newSifre.map(item => (

                                                <span
                                                    key={item.Id}
                                                    className="badge badge-light-success fs-6 px-3 py-2 d-flex align-items-center"
                                                >

                                        {item.sifra}

                                                    <span
                                                        className="ms-2 cursor-pointer text-danger"
                                                        onClick={() => removeNewSifra(item.sifra)}
                                                    >
                                            <KTIcon iconName="cross" className="fs-5"/>
                                        </span>

                                    </span>

                                            ))}

                                        </div>

                                    </div>

                                </div>


                                {/* ADD NEW SIFRA */}
                                <div className="card border border-dashed border-primary p-4">

                                    <div className="d-flex align-items-center mb-3">

                                        <KTIcon iconName="key" className="fs-3 text-primary me-2"/>

                                        <span className="fw-bold">
                                Dodaj novu šifru
                            </span>

                                    </div>

                                    <div className="d-flex gap-3">

                                        <input
                                            type="text"
                                            className="form-control form-control-lg"
                                            placeholder="Unesite šifru panela..."
                                            value={newSifraInput}
                                            onChange={(e) => setNewSifraInput(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault()
                                                    addSifra()
                                                }
                                            }}
                                        />

                                        <button
                                            className="btn btn-primary px-6"
                                            onClick={addSifra}
                                        >
                                            <KTIcon iconName="plus" className="fs-4 me-1"/>
                                            Dodaj
                                        </button>

                                    </div>

                                </div>

                            </div>


                            {/* FOOTER */}
                            <div className="modal-footer border-0 pt-2 flex-column align-items-start">

                                <div className="alert alert-danger w-100 py-3 mb-3">

                                    <div className="d-flex align-items-center">

                                        <KTIcon iconName="information-5" className="fs-2 text-danger me-2"/>

                                        <span className="fs-4">
                                            Važno: Dodane šifre neće biti sačuvane dok ne kliknete dugme
                                            <strong> "Sačuvaj"</strong>.
                                        </span>

                                    </div>

                                </div>

                                <div className="d-flex justify-content-end w-100">

                                    <button
                                        className="btn btn-light me-3"
                                        onClick={() => setShowSifraModal(false)}
                                    >
                                        Zatvori
                                    </button>

                                    <button
                                        className="btn btn-success px-6"
                                        onClick={saveSifre}
                                        disabled={savingSifre}
                                    >
                                        {savingSifre ? "Spašavanje..." : "Sačuvaj"}
                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            )}
            <IzvjestajiModal
                show={showIzvjestajiModal}
                onClose={() => setShowIzvjestajiModal(false)}
            />
        </KTCard>

    )
}

export default DigitalniDop